import { AccordionSlice } from '../../prismicio-types'
import styles from './Accordion.module.css'
import { asHTML } from '@prismicio/client'
import linkResolver from '../linkResolver'

const Arrow = /* HTML */ `
	<svg viewBox="0 0 20 12" xmlns="http://www.w3.org/2000/svg">
		<path d="M1 1.19238L10.0156 10.208L19.0312 1.19238" />
	</svg>
`

class Item {
	private readonly node: HTMLElement
	private readonly button: HTMLElement

	constructor(node: HTMLElement) {
		this.onClick = this.onClick.bind(this)
		this.node = node
		this.button = node.querySelector(`.${styles.Button}`)!
		this.button.addEventListener('click', this.onClick)
	}

	onClick() {
		this.node.classList.toggle(styles.IsOpen)
	}

	dispose() {
		this.button.addEventListener('click', this.onClick)
	}
}

export class Accordion {
	private readonly items: Item[]

	constructor(private readonly node: HTMLElement) {
		this.items = Array.from(this.node.querySelectorAll(`.${styles.Item}`) as NodeListOf<HTMLElement>).map(
			(item) => new Item(item)
		)
	}

	dispose() {
		this.items.forEach((item) => item.dispose())
	}

	static render(props: AccordionSlice) {
		const {
			primary: { title },
			items
		} = props

		return /* HTML */ `
			<div class="${styles.Main}">
				${title ? `<div class="${styles.Title}">${title}</div>` : ''}
				<div>
					${items
						.map(({ text, full_text }) => {
							if (full_text && full_text[0]) {
								return /* HTML */ `<div class="${styles.Item}">
									<button class="${styles.Button}"><span>${asHTML(text)}</span>${Arrow}</button>
									<div class="${styles.Text}">${asHTML(full_text)}</div>
								</div>`
							} else {
								return /* HTML */ `<div class="${styles.Item}">
									<div class="${styles.Button}">
										<span>${asHTML(text, { linkResolver })}</span>
									</div>
								</div>`
							}
						})
						.join('')}
				</div>
			</div>
		`
	}
}
